import $ from 'jquery';

export function init() {
  $('body').on('change', '.selector>select', function (e) {
    $(e.currentTarget).prev('span').text($('option:selected', e.currentTarget).text());
  });

  $('body').on('navigation UpdateLatestViewedAccommodation', function () {
    update();
  });

  update();
}

function update() {
  $('.selector>select').each(function () {
    $(this).prev('span').text($('option:selected', this).text());
  });
}